/* eslint-disable import/prefer-default-export */
import React from 'react'
import PropTypes from 'prop-types'

import s from './AgentProfile.module.css'

export function AgentProfile(props) {
  const { agent, image } = props

  const isEmployee = agent.employee

  return (
    <div className={s.root}>
      <div className={s.profile}>
        {image && (
          <div className={s.imageWrapper}>
            <img src={image} alt={`${agent.first_name} ${agent.last_name}`} className={s.image} />
          </div>
        )}

        <div className={s.agent}>
          <div className={s.agentName}>
            {agent.first_name} {agent.last_name}
          </div>
          {isEmployee && (
            <>
              {(agent.super_admin || agent.admin) && (
                <div className={s.agentInfo}>{agent.title && `${agent.title},`} Nooklyn</div>
              )}

              {agent.photographer && !agent.super_admin && <div className={s.agentInfo}>Photographer, Nooklyn</div>}

              {agent.license_number && agent.license_number.length > 0 && (
                <>
                  <div className={s.agentInfo}>Licensed Real Estate Salesperson</div>
                  <div className={s.agentInfo}>License #: {agent.license_number}</div>
                  {agent.licensed_as && <div className={s.agentInfo}>Licensed As {agent.licensed_as}</div>}
                </>
              )}
            </>
          )}
        </div>
      </div>

      <div className={s.agentAbout}>
        {agent.description || <>{agent.first_name} hasn&apos;t filled out their description yet.</>}
      </div>
    </div>
  )
}

AgentProfile.propTypes = {
  image: PropTypes.string,
  agent: PropTypes.shape({
    account_type: PropTypes.string.isRequired,
    admin: PropTypes.bool.isRequired,
    app_two_factor_enabled_at: PropTypes.string,
    app_two_factor_secret: PropTypes.string,
    created_at: PropTypes.string.isRequired,
    daily_summary: PropTypes.string,
    deleted_at: PropTypes.string,
    description: PropTypes.string,
    email: PropTypes.string.isRequired,
    email_notifications: PropTypes.bool.isRequired,
    email_opt_in: PropTypes.bool.isRequired,
    employee: PropTypes.bool.isRequired,
    employer: PropTypes.bool.isRequired,
    facebook_url: PropTypes.string,
    finance: PropTypes.bool.isRequired,
    finance_manager: PropTypes.bool.isRequired,
    first_name: PropTypes.string.isRequired,
    former_employee: PropTypes.bool.isRequired,
    gender: PropTypes.string,
    gender_pronouns: PropTypes.string,
    has_attached_profile_picture: PropTypes.bool.isRequired,
    id: PropTypes.number.isRequired,
    image: PropTypes.string,
    last_name: PropTypes.string.isRequired,
    license_expires_on: PropTypes.string,
    license_number: PropTypes.string,
    license_submitted_at: PropTypes.string,
    license_verified_at: PropTypes.string,
    license_verified_by_id: PropTypes.number,
    licensed_as: PropTypes.string,
    nooklyn_engineer: PropTypes.bool.isRequired,
    oauth_expires_at: PropTypes.string,
    oauth_refresh_token: PropTypes.string,
    oauth_token: PropTypes.string,
    on_probation: PropTypes.bool.isRequired,
    on_vacation: PropTypes.bool.isRequired,
    phone: PropTypes.string,
    photo_request_moderator: PropTypes.bool.isRequired,
    photographer: PropTypes.bool.isRequired,
    platform_moderator: PropTypes.bool.isRequired,
    platform_multiple_listings: PropTypes.bool.isRequired,
    private_profile: PropTypes.bool.isRequired,
    profile_picture_attached_at: PropTypes.string,
    provider: PropTypes.string,
    rating: PropTypes.number,
    read_only: PropTypes.bool.isRequired,
    region_id: PropTypes.number,
    restrict_phone: PropTypes.bool.isRequired,
    slug: PropTypes.string.isRequired,
    sms_notifications: PropTypes.bool.isRequired,
    sms_two_factor_enabled_at: PropTypes.string,
    sms_two_factor_secret: PropTypes.string,
    state_id_approved_at: PropTypes.string,
    state_id_processed_at: PropTypes.string,
    state_id_rejected_at: PropTypes.string,
    state_id_submitted_at: PropTypes.string,
    super_admin: PropTypes.bool.isRequired,
    support: PropTypes.bool.isRequired,
    suspended: PropTypes.bool.isRequired,
    title: PropTypes.string,
    tos_accepted_at: PropTypes.string,
    two_factor_last_verified_at: PropTypes.string,
    uid: PropTypes.string,
    updated_at: PropTypes.string.isRequired,
    _dev_device: PropTypes.bool.isRequired,
    _device_token: PropTypes.string,
    _licensed_as: PropTypes.string,
    _old_phone: PropTypes.string,
  }),
}
